module.exports = __webpack_public_path__ + "media/images/recruit/credo/img-whatwedo-b939b9cc8e6676b6e7ae2683c7c9a529.svg";